export default "__VITE_ASSET__2da26e00__"